export const SET_NEWS = 'SET_NEWS';
export const RESET_NEWS = 'RESET_NEWS';